export default __webpack_public_path__ + "static/media/Monocal-D-Box-ban.99c56f00.jpg";